import { render } from "./index.vue?vue&type=template&id=f728674a&bindings={\"post\":\"props\",\"canDelete\":\"props\",\"deletePost\":\"options\"}"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "f728674a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f728674a')) {
    api.reload('f728674a', script)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=f728674a&bindings={\"post\":\"props\",\"canDelete\":\"props\",\"deletePost\":\"options\"}", () => {
    api.rerender('f728674a', render)
  })

}

script.__file = "resources/js/Components/ClassroomPost/index.vue"

export default script